// The pure rules behind the Getting started card, kept out of the component so they can be tested.

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// The things the old welcome screen asked a person to confirm, before the welcome video moved here (its bounty question
// went when bounties were retired).
export const WELCOME_QUESTIONS = [
  { id: "tracking", text: "Do you understand how work is tracked and evaluated here?" },
  { id: "culture", text: "Do you understand that our culture requires responsibility, continuous learning and growth?" },
  { id: "behavior", text: "Do you understand that irresponsible behaviour is unacceptable and may lead to consequences?" },
  { id: "communication", text: "Do you clearly understand where to communicate and where to update EOD reports and leaves (Slack, the intranet or GitHub)?" },
];

// Required steps first, each group in the order the server sent them.
export function groupSteps(items) {
  const list = Array.isArray(items) ? items : [];
  return { required: list.filter((i) => i.required), optional: list.filter((i) => !i.required) };
}

export function progress(items) {
  const list = Array.isArray(items) ? items : [];
  const done = list.filter((i) => i.done).length;
  return { done, total: list.length, percent: list.length ? Math.round((100 * done) / list.length) : 100 };
}

// What the heading says: the required steps are the ones that matter, so they are what is counted.
export function headline(data) {
  const left = Number(data?.remaining_required || 0);
  if (left > 0) return `${left} required ${left === 1 ? "step" : "steps"} left`;
  const rest = Number(data?.remaining || 0);
  return rest > 0 ? `${rest} optional ${rest === 1 ? "step" : "steps"} left` : "All done";
}

// A person is junior when their employment type says so; the culture points differ for them.
export function seniorityOf(employmentType) {
  return /intern|trainee|junior|apprentice/i.test(String(employmentType || "")) ? "junior" : "full";
}

export function trackOf(departmentFamily) {
  return /sales/i.test(String(departmentFamily || "")) ? "sales" : "eng";
}

// "10:00" and "18:00" on a chosen set of days; the server checks the same things and answers in plain words.
export function hoursProblem({ start, end, weekdays }) {
  if (!start || !end) return "Give the time you start and the time you finish.";
  if (end <= start) return "Your finishing time must be later than your starting time.";
  if (!weekdays || weekdays.length === 0) return "Choose the days you work.";
  return "";
}

export function toggleDay(days, day) {
  const set = new Set(days);
  if (set.has(day)) set.delete(day); else set.add(day);
  return [...set].sort((a, b) => a - b);
}
